<template>
    <nav class="MainNav" :class="{'is-opened': isOpened}" @click.self="closeMenu">
        <ul class="MainNav-list">
            <span class="MainNav-list-exitButton" :class="{'is-opened': isOpened}" @click="closeMenu">×</span>
            <li><a href="https://zelenekolo.cz/">ÚVOD</a></li>
            <li class="hasChildren"><a href="#" @click="openDropDown">NAŠE SLUŽBY</a>
                <span class="Dropdown">
                    <ul class="NavDropdown">
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/projekty/">Projekty</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/zahrady/">Zahrady</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/stavby/">Stavby</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/zelen/">Zeleň</a></li>
                    </ul>
                </span>
            </li>
            <li><a href="https://zelenekolo.cz/rezervace/">REZERVACE</a></li>
            <li>
                <router-link :to="{ name: 'home' }" class="MainNav-currentPage">ZELENÁ KALKULAČKA</router-link>
            </li>
            <li class="hasChildren"><a href="#" @click="openDropDown">NOVINKY</a>
                <span class="Dropdown">
                    <ul class="NavDropdown">
                        <li class="NavDropdown-item desktopHidden"><a href="https://zelenekolo.cz/novinky/">Novinky</a></li>
                        <li class="NavDropdown-item"><a href="https://blog.zelenekolo.cz/">blog</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/rubriky/referencni-stavby/">reference</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/mapa-zakazek/">mapa zakázek</a></li>
                    </ul>
                </span>
            </li>
            <li class="desktopHidden"><a href="https://zelenekolo.cz/kariera/" class="NavDropdown-item">KARIÉRA</a></li>
            <li class="hasChildren desktopHidden"><a href="#" @click="openDropDown">DALŠÍ INFORMACE</a>
                <span class="Dropdown">
                    <ul class="NavDropdown">
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/o-nas/">O NÁS</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/o-nas/podporujeme/">PODPORUJEME</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/o-nas/clenstvi-v-szkt/">ČLENSTVÍ V SZKT</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/obchodni-podminky/">DOKUMENTY KE STAŽENÍ</a></li>
                        <li class="NavDropdown-item"><a
                            href="https://zelenekolo.cz/prohlaseni-o-nakladani-s-osobnimi-udaji/">OCHRANA OSOBNÍCH ÚDAJŮ</a></li>
                        <li class="NavDropdown-item"><a
                            href="https://zelenekolo.cz/dotaznik/">DOTAZNÍK K VAŠI ZAHRADĚ</a></li>
                    </ul>
              </span>
            </li>
            <li class="shown"><a href="https://zelenekolo.cz/o-nas/" @click="openDropDown">O NÁS</a>
                <span class="Dropdown">
                    <ul class="NavDropdown">
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/kariera/">kariéra</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/o-nas/podporujeme/">podporujeme</a></li>
                        <li class="NavDropdown-item"><a href="https://zelenekolo.cz/o-nas/clenstvi-v-szkt/">ČLENSTVÍ V SZKT</a></li>
                    </ul>
            </span>
            </li>
            <li><a href="https://zelenekolo.cz/kontakt/">KONTAKT</a></li>
        </ul>
    </nav>
    <div class="NavHamburger" @click="openMenu">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
import {ref} from 'vue';

export default {
    setup() {
        const isOpened = ref(false);

        const isOpenedDrop = ref(false);

        const openMenu = () => isOpened.value = true;

        const closeMenu = () => isOpened.value = false;

        const openDropDown = (e) => {
            e.target.nextSibling.classList.toggle("selected");
            e.target.classList.toggle("selected-link")
        }

        return {
            isOpened,
            isOpenedDrop,
            openMenu,
            closeMenu,
            openDropDown
        }
    }
}
</script>

<style lang="scss" scoped>
.MainNav {
    $block: &;
    align-self: stretch;
    min-height: 6.5em;

    @media(min-width: 1000px) {
        transition: all 0.1s ease-in-out;
    }

    @media(max-width: 1000px) {
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(43, 41, 40, 0.9);
        z-index: 4;
        opacity: 0;
        pointer-events: none;
        overflow: auto;

        &.is-opened {
            pointer-events: auto;
            opacity: 1;
            transform: none;
        }
    }

    .shown {
        display: flex;
        @media (max-width: 1000px) {
            display: none;
        }
    }

    &-list {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0;
        height: 100%;
        @media(max-width: 1000px) {
            flex-wrap: nowrap;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            transition: all .4s ease-in-out;
            opacity: 0;
            height: 100%;
            overflow: auto;
            transform: translate3d(0, 30px, 0);
            letter-spacing: 3px;
            #{$block}.is-opened & {
                opacity: 1;
                transform: none;
                width: 100%;
            }
        }

        &-exitButton {
            position: absolute;
            text-align: center;
            top: 40px;
            right: 30px;
            height: 40px;
            width: 40px;
            line-height: 36px;
            font-size: 18px;
            color: #f1b458;
            z-index: 10;
            border: 2px solid rgba(255, 255, 255, 0.2);
            cursor: pointer;
            display: none;
            visibility: hidden;

            &.is-opened {
                visibility: visible;
            }

            @media (max-width: 1000px) {
                display: block;
            }
        }

        li {
            padding-left: 16px;
            margin-left: 16px;
            height: 100%;
            position: relative;
            @media(max-width: 1000px) {
                height: auto;
                display: flex;
                margin: 0 0 0.4rem 0;
                padding: 0.625rem 0;
                justify-content: center;
                flex-direction: column;
                align-items: center;
            }
            @media(max-width: 450px) {
                padding: 6px 0;
            }

            &:hover {

                @media(min-width: 1000px) {
                    .Dropdown {
                        visibility: visible;
                        opacity: 1;
                    }
                }
            }

            a {
                text-decoration: none;
                color: var(--colorText);
                font-weight: 600;
                letter-spacing: 1px;
                height: 100%;
                display: flex;
                align-items: center;
                transition: all .25s ease-in-out;
                font-size: 14px;
                position: relative;
                @media(max-width: 1000px) {
                    margin: 0 auto;
                    font-family: 'Raleway', sans-serif;
                    color: #fff;
                    height: unset;
                    letter-spacing: 3px;
                    font-weight: 800;
                    font-size: 28px;
                    line-height: 36px;
                    padding: 0 30px;
                }
                @media(max-width: 450px){
                    line-height: 26px;
                    font-size: 20px;
                }

                &:after {
                    content: ' ';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    transform: scaleX(0);
                    background: var(--colorBrand);
                    transform-origin: top left;
                    height: 2px;
                    transition: all .3s ease-in-out;
                    @media(max-width: 1000px) {
                        display: none;
                    }
                }

                &:hover, &.MainNav-currentPage {

                    @media(min-width: 1000px) {
                        color: var(--colorBrand);
                    }

                    @media(max-width: 1000px) {
                        color: #f1b458;
                        &::before {
                            border-color: #f1b458;
                        }
                    }

                    &:after {
                        transform: scaleX(1);
                    }
                }

                &.selected-link {
                    @media (max-width: 1000px) {

                        color: #f1b458;
                    }
                }

                &.selected-link::before {
                    border-color: #f1b458;
                }
            }
        }

        .hasChildren > a::before {
            @media (max-width: 1000px) {
                content: "";
                position: absolute;
                width: 0.4rem;
                height: 0.4rem;
                right: 0;
                transform-origin: center center;
                top: 50%;
                transform: translateY(-50%) rotate(45deg);
                border: solid #fff;
                border-width: 0 2px 2px 0;
            }
        }
    }

    .Dropdown {
        visibility: hidden;
        @media (min-width: 1000px) {
            width: 200px;
            background: var(--colorBrandLighten);
            line-height: 24px;
            position: absolute;
            z-index: 60;
            top: 100%;
            left: 0;
            padding: .5em 0;
            opacity: 0;
            transition: all 0.3s ease-in-out;
        }
        @media (max-width: 1000px) {
            overflow: hidden;
            max-height: 0;
            transition: max-height 0.4s linear;
        }

        .NavDropdown {
            list-style: none;
            padding: 0;

            .NavDropdown-item {
                text-transform: uppercase;
                margin: 0;
                color: #807737;
                padding: 0.5rem 0.625rem;
                transition: all 0.1s ease-in-out;

                &:last-child {
                    padding-bottom: 0;
                }

                a {
                    color: var(--colorBrandDark);
                    @media (max-width: 1000px) {
                        color: rgba(255, 255, 255, 0.7);
                        font-size: 24px;
                    }
                    @media (max-width: 450px) {
                        font-size: 16px;
                        line-height: 22px;
                    }
                }

                a:hover {
                    &:after {
                        content: none;
                    }

                    color: var(--colorBrand);
                    @media(max-width: 1000px) {
                        color: #f1b458;
                    }
                }
            }
        }
    }

    .desktopHidden {
        display: none;
        @media (max-width: 1000px) {
            display: flex;
        }
    }

    .selected {
        @media (max-width: 1000px) {
            max-height: 1000px;
            overflow: hidden;
            visibility: visible;
            position: relative;
            background: transparent;
            top: 0;
            left: 0;
            .NavDropdown {
                background: transparent;
            }
        }
    }

}


.NavHamburger {
    display: none;
    cursor: pointer;
    @media(max-width: 1000px) {
        display: block;
    }

    span {
        background: var(--colorBrandDark);
        display: block;
        width: 36px;
        height: 4px;

        &:nth-child(2) {
            margin: .5em 0;
        }
    }
}
</style>